import { AppTheme, ExtendedThemePalette } from '@ms/acui-theme';
var errorLightThemePalette = {
    errorBackgroundColor: ExtendedThemePalette.redLighter,
    severeBackgroundColor: ExtendedThemePalette.orangeLight,
    successBackgroundColor: ExtendedThemePalette.greenLighter,
    warningBackgroundColor: ExtendedThemePalette.yellowLight,
    errorIconColor: ExtendedThemePalette.red,
    severeIconColor: ExtendedThemePalette.orange,
    successIconColor: ExtendedThemePalette.green,
};
var errorDarkThemePalette = {
    errorBackgroundColor: ExtendedThemePalette.redDark,
    severeBackgroundColor: ExtendedThemePalette.orangeDark,
    successBackgroundColor: ExtendedThemePalette.greenDark,
    warningBackgroundColor: ExtendedThemePalette.yellowDark,
    errorIconColor: ExtendedThemePalette.redLight,
    severeIconColor: ExtendedThemePalette.yellow,
    successIconColor: ExtendedThemePalette.greenLight,
};
export var getErrorSemanticColors = function (theme) {
    return theme === AppTheme.Dark ? errorDarkThemePalette : errorLightThemePalette;
};
//# sourceMappingURL=errorSemanticColors.js.map